/*
 * @Author: goldeneyes.li
 * @Date: 2022-10-31 16:05:56
 * @LastEditTime: 2023-02-18 23:46:25
 * @LastEditors: goldeneyes.li
 * @Description: 各种转换工具
 */
import SparkMD5 from 'spark-md5'
import { isArray, isEmpty, isObject, isString } from './validate'
import numeral from 'numeral'
import mime from 'mime-types'
import _ from 'lodash'

/**
 * @description: 文件加密处理
 */
export function getMD5(file) {
    return new Promise((resolve, reject) => {
        const spark = new SparkMD5.ArrayBuffer()
        // 获取文件二进制数据
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file.raw) // file 就是获取到的文件
        // 异步执行函数
        fileReader.addEventListener('load', (e) => {
            spark.append(e.target.result)
            const md5 = spark.end()
            resolve(md5)
        })
        fileReader.addEventListener('error', (e) => {
            reject(e)
        })
    })
}

/**
 * @description 文件大小格式化
 * @param {*} size
 */
export function formatFileSize(size) {
    var fileSize = 0
    var suffix = 'B'

    if (size < 1024) {
        suffix = 'B'
        fileSize = size
    } else if (size / 1024 < 1024) {
        suffix = 'KB'
        fileSize = Math.round(size / 1024)
    } else if (size / 1024 / 1024 < 1024) {
        suffix = 'MB'
        fileSize = (Math.round((size * 100) / (1024 * 1024)) / 100).toString()
    } else if (size / 1024 / 1024 / 1024 < 1024) {
        suffix = 'GB'
        fileSize = (Math.round((size * 100) / (1024 * 1024 * 1024)) / 100).toString()
    }
    var fileSizeParts = fileSize.toString().split('.')
    fileSize = fileSizeParts[0]
    if (fileSizeParts.length > 1) {
        fileSize += '.' + fileSizeParts[1].substr(0, 2)
    }
    fileSize += suffix
    return fileSize
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param list 含有父子关系的数组
 * @param pid 父id属性名
 * @param id id属性名
 * @param root 根id值
 * @returns {*}
 */
export function translateDataToTree(list, pid, id, rootKey = '') {
    let root = list.filter((m) => m[pid] == rootKey)

    if (list && list.length) {
        const group = {}
        for (let index = 0; index < list.length; index += 1) {
            if (list[index][pid] !== null && list[index][pid] !== undefined) {
                if (!group[list[index][pid]]) {
                    group[list[index][pid]] = []
                }
                group[list[index][pid]].push(list[index])
            }
        }
        const queue = []
        root.map((m) => {
            queue.push(m)
        })
        while (queue.length) {
            const node = queue.shift()
            node.children = group[node[id]] && group[node[id]].length ? group[node[id]] : null
            // hideAllCheckbox为true，隐藏Checkbox，子节点继承父节点
            if (node.hideAllCheckbox) {
                node.hideCheckbox = true
                node.children?.map((m) => {
                    m.hideAllCheckbox = true
                    m.hideCheckbox = true
                })
            }
            if (node.children) {
                queue.push(...node.children)
            }
        }
    }
    return root
}

/**
 * @description: 树形结构数据转换成父子关系的一维数组
 * @param {array} list 初始数组
 * @param {string} id id属性名
 * @param {string} pid 父id属性名
 * @param {string} childrenName 子数组属性名
 * @param {Object} parent 父级(无需传入)
 */
export function translateTreeToData(list, id, pid, childrenName, parent = null) {
    let arr = []
    if (isArray(list)) {
        list.map((obj) => {
            let item = cloneDeep(obj)
            item.pid = isEmpty(parent) ? undefined : parent[id]
            if (isArray(item[childrenName])) {
                arr.push(...translateTreeToData(item[childrenName], id, pid, childrenName, item))
            }
            delete item[childrenName]
            arr.push(item)
        })
    }
    return arr
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 16) {
    // const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
    const num = 'abcdefghijklmnopqrstuvwxyz1234567890'
    let str = ''
    for (let i = 0; i < length; i++) {
        str += num.charAt(Math.floor(Math.random() * num.length))
    }
    return str
}

/**
 * @description 获取两个数组中的差异部分
 * @param arr1 数组1
 * @param arr2 数组2
 * @returns {array} 返回差异值组成的数组
 */
export function get2ArrDifferences(arr1, arr2) {
    const arr = [...arr1, ...arr2]
    const newArr = arr.filter((item) => {
        return !(arr1.includes(item) && arr2.includes(item))
    })
    return newArr
}

/**
 * @description 单个从 数组中移除项
 * @param arr 数组
 * @param key 数组对象时为键，数组时为空
 * @param val 要移除项的值
 * @returns {array}
 */
export function removeItem(arr, key, val) {
    if (arr != undefined && arr.length > 0) {
        if (key == '') {
            return arr.filter((m) => m != val)
        } else {
            return arr.filter((m) => m[key] != val)
        }
    }
    return arr
}

/**
 * @description 批量从 数组中移除项
 * @param arr 数组
 * @param key 数组对象是为键，数组时为空
 * @param valArr 要移除项的值，数组
 * @returns {array}
 */
export function removeItems(arr, key, valArr) {
    if (valArr.length > 0) {
        if (key == '') {
            return arr.filter((m) => !valArr.includes(m))
        } else {
            return arr.filter((m) => !valArr.includes(m[key]))
        }
    }
    return arr
}

/**
 * @description 实体中移除 create和update各4个属性
 * @param obj 数组
 * @param delteFileds 其它需要移除的属性
 * @returns {{}}
 */
export function deleteFiled(obj, delteFileds) {
    if (obj.createTime) delete obj.createTime
    if (obj.createAccount) delete obj.createAccount
    if (obj.createName) delete obj.createName
    if (obj.createGuid) delete obj.createGuid
    if (obj.updateTime) delete obj.updateTime
    if (obj.updateAccount) delete obj.updateAccount
    if (obj.updateName) delete obj.updateName
    if (obj.updateGuid) delete obj.updateGuid
    if (delteFileds) {
        delteFileds.map((m) => {
            if (obj[m]) {
                delete obj[m]
            }
        })
    }
    return obj
}

/**
 * @description 首字母转小写
 * @param {string} value
 */
export function firstLowerCase(value) {
    return value.replace(/^\S/, (s) => s.toLowerCase())
}

/**
 * @description 数组求合
 * @param  {arrary} arr
 */
export function calcSum(arr) {
    const array = arr.filter((m) => m != '')
    if (array.length == 0) {
        return 0
    } else if (array.length == 1) {
        return array[0]
    } else {
        return array.reduce((n, m) => n + m)
    }
}

/**
 * @description 数组取最大值
 * @param  {arrary} arr 数组
 * @param  {string} key 要查找最大值的属性
 * @param  {boolean} isReturnObj 返回最大值还是返回最大值的对象(默认返回最大值)
 */
export function calcMax(arr, key, isReturnObj = false) {
    const array = key ? arr.filter((m) => !isEmpty(m[key])) : arr.filter((m) => !isEmpty(m))
    if (array.length == 0) {
        return isReturnObj ? null : 0
    } else if (array.length == 1) {
        return key ? (isReturnObj ? array[0] || null : array[0][key] || 0) : array[0]
    } else {
        return key
            ? isReturnObj
                ? array.sort((x, y) => y[key] - x[key])[0]
                : array.sort((x, y) => y[key] - x[key])[0][key]
            : array.sort((x, y) => y - x)[0]
    }
}

/**
 * @description 数组取最小值
 * @param  {arrary} arr 数组
 * @param  {string} key 要查找最小值的属性
 * @param  {boolean} isReturnObj 返回最小值还是返回最小值的对象(默认返回最小值)
 */
export function calcMin(arr, key, isReturnObj = false) {
    const array = key ? arr.filter((m) => !isEmpty(m[key])) : arr.filter((m) => !isEmpty(m))
    if (array.length == 0) {
        return isReturnObj ? null : 0
    } else if (array.length == 1) {
        return key ? (isReturnObj ? array[0] || null : array[0][key] || 0) : array[0]
    } else {
        return key
            ? isReturnObj
                ? array.sort((x, y) => x[key] - y[key])[0]
                : array.sort((x, y) => x[key] - y[key])[0][key]
            : array.sort((x, y) => x - y)[0]
    }
}

/**
 * @description JSON字符串转为JSON对象
 * @param  {*} value
 */
export function safelyJSONParse(value) {
    if (!value) {
        return null
    } else if (isObject(value)) {
        return value
    } else if (isString(value)) {
        try {
            return JSON.parse(value)
        } catch (error) {
            return {}
        }
    } else {
        return {}
    }
}

/**
 * @description 数组随机取值
 * @param {} arr
 */
export function randomArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)]
}

/**
 * @description 从url中解析参数
 * @name getUrlParams
 * @param {string} param
 */
export function getUrlParams(param) {
    var data = window.location.href
    if (data.indexOf('?') < 0) return undefined //判断是否存在参数
    var allParamsArr = data.split('?')[1].split('&'),
        returnObj = {}
    if (allParamsArr.length == 0) return undefined //参数是否带参
    for (var i = 0; i < allParamsArr.length; i++) {
        returnObj[`${allParamsArr[i].split('=')[0]}`] = decodeURIComponent(allParamsArr[i].split('=')[1])
    }
    return returnObj[`${param}`]
}

/**
 * @description 从url添加指定参数
 */
export function addUrlParam(param, url) {
    if (!url) {
        url = window.location.href
    }
    // 先判断有没有重名参数，有则先删除
    url = delUrlParam(param.name, url)
    url += (url.split('?')[1] ? '&' : '?') + param.name + '=' + param.value
    return url
}

/**
 * @description 从url删除指定参数
 */
export function delUrlParam(paraName, url) {
    if (!url) {
        url = window.location.href
    }
    let urlparts = url.split('?')
    if (urlparts.length >= 2) {
        //参数名前缀
        let prefix = encodeURIComponent(paraName) + '='
        let pars = urlparts[1].split(/[&;]/g)

        //循环查找匹配参数
        for (let i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                //存在则删除
                pars.splice(i, 1)
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
    }
    return url
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
            decodeURIComponent(search)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"')
                .replace(/\+/g, ' ') +
            '"}'
    )
}

/**
 * @description file或blob转base64
 * @param {*} blob file或者blob
 */
export function blobToBase64(blob) {
    return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(blob)
        reader.onload = function () {
            imgResult = reader.result
        }
        reader.onerror = function (error) {
            reject(error)
        }
        reader.onloadend = function () {
            resolve(imgResult)
        }
    })
}

/**
 * @description base64转file
 * base64格式：data:image/png;base64,iVBORw0KGgoAAAANSU...
 * @param {*} dataURL base64编码数据
 * @param {*} filename 文件名称
 */
export function base64ToFile(dataURL, filename) {
    const arr = dataURL.split(','),
        mime = arr[0].match(/:(.*?);/)[1], //mime类型 image/png
        bstr = atob(arr[1]) //base64 解码

    let n = bstr.length,
        u8arr = new Uint8Array(n)

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
}

/**
 * @description 格式化数字
 */
export function formatNumber(number, format) {
    let n = numeral(number)
    if (!isEmpty(format)) {
        return n.format(format)
    } else {
        return n._value
    }
}

/**
 * @description 深拷贝
 * @param {Object} value
 * @returns
 */
export function cloneDeep(value) {
    return _.cloneDeep(value)
}

/**
 * @description: 合并对象
 * @param {object} object 目标对象
 * @param {*} source 来源对象
 * @return {*}
 */
export function merge(object, source) {
    return _.merge(object, source)
}

/**
 * @description 删除字符串中的数字或非数字
 * @param {string} str 字符串
 * @param {boolean} replaceNumber 默认true，true表示从字符串中删除数字保留字符， false表示从字符串中删除字符保留数字
 * @returns {string} 返回删除数字的字符串或删除字符串的数字
 */
export function replaceString(str, replaceNumber = true) {
    if (!str) return ''
    str = isString(str) ? str : str.toString()
    return replaceNumber ? str.replace(/[0-9]/gi, '') : str.replace(/[^0-9]/gi, '')
}

/**
 * @description 删除字符串中的中文
 * @param {string} str 字符串
 * @returns {string} 返回删除中文的字符串
 */
export function replaceChinese(str) {
    str = isString(str) ? str : str.toString()
    // 汉字拼音首字母列表 本列表包含了20902个汉字,用于配合 ToChineseSpell
    //函数使用,本表收录的字符的Unicode编码范围为19968至40869
    const strChineseFirstPY =
        'YDYQSXMWZSSXJBYMGCCZQPSSQBYCDSCDQLDYLYBSSJGYZZJJFKCCLZDHWDWZJLJPFYYNWJJTMYHZWZHFLZPPQHGSCYYYNJQYXXGJHHSDSJNKKTMOMLCRXYPSNQSECCQZGGLLYJLMYZZSECYKYYHQWJSSGGYXYZYJWWKDJHYCHMYXJTLXJYQBYXZLDWRDJRWYSRLDZJPCBZJJBRCFTLECZSTZFXXZHTRQHYBDLYCZSSYMMRFMYQZPWWJJYFCRWFDFZQPYDDWYXKYJAWJFFXYPSFTZYHHYZYSWCJYXSCLCXXWZZXNBGNNXBXLZSZSBSGPYSYZDHMDZBQBZCWDZZYYTZHBTSYYBZGNTNXQYWQSKBPHHLXGYBFMJEBJHHGQTJCYSXSTKZHLYCKGLYSMZXYALMELDCCXGZYRJXSDLTYZCQKCNNJWHJTZZCQLJSTSTBNXBTYXCEQXGKWJYFLZQLYHYXSPSFXLMPBYSXXXYDJCZYLLLSJXFHJXPJBTFFYABYXBHZZBJYZLWLCZGGBTSSMDTJZXPTHYQTGLJSCQFZKJZJQNLZWLSLHDZBWJNCJZYZSQQYCQYRZCJJWYBRTWPYFTWEXCSKDZCTBZHYZZYYJXZCFFZZMJYXXSDZZOTTBZLQWFCKSZSXFYRLNYJMBDTHJXSQQCCSBXYYTSYFBXDZTGBCNSLCYZZPSAZYZZSCJCSHZQYDXLBPJLLMQXTYDZXSQJTZPXLCGLQTZWJBHCTSYJSFXYEJJTLBGXSXJMYJQQPFZASYJNTYDJXKJCDJSZCBARTDCLYJQMWNQNCLLLKBYBZZSYHQQLTWLCCXTXLLZNTYLNEWYZYXCZXXGRKRMTCNDNJTSYYSSDQDGHSDBJGHRWRQLYBGLXHLGTGXBQJDZPYJSJYJCTMRNYMGRZJCZGJMZMGXMPRYXKJNYMSGMZJYMKMFXMLDTGFBHCJHKYLPFMDXLQJJSMTQGZSJLQDLDGJYCALCMZCSDJLLNXDJFFFFJCZFMZFFPFKHKGDPSXKTACJDHHZDDCRRCFQYJKQCCWJDXHWJLYLLZGCFCQDSMLZPBJJPLSBCJGGDCKKDEZSQCCKJGCGKDJTJDLZYCXKLQSCGJCLTFPCQCZGWPJDQYZJJBYJHSJDZWGFSJGZKQCCZLLPSPKJGQJHZZLJPLGJGJJTHJJYJZCZMLZLYQBGJWMLJKXZDZNJQSYZMLJLLJKYWXMKJLHSKJGBMCLYYMKXJQLBMLLKMDXXKWYXYSLMLPSJQQJQXYXFJTJDXMXXLLCXQBSYJBGWYMBGGBCYXPJYGPEPFGDJGBHBNSQJYZJKJKHXQFGQZKFHYGKHDKLLSDJQXPQYKYBNQSXQNSZSWHBSXWHXWBZZXDMNSJBSBKBBZKLYLXGWXDRWYQZMYWSJQLCJXXJXKJEQXSCYETLZHLYYYSDZPAQYZCMTLSHTZCFYZYXYLJSDCJQAGYSLCQLYYYSHMRQQKLDXZSCSSSYDYCJYSFSJBFRSSZQSBXXPXJYSDRCKGJLGDKZJZBDKTCSYQPYHSTCLDJDHMXMCGXYZHJDDTMHLTXZXYLYMOHYJCLTYFBQQXPFBDFHHTKSQHZYYWCNXXCRWHOWGYJLEGWDQCWGFJYCSNTMYTOLBYGWQWESJPWNMLRYDZSZTXYQPZGCWXHNGPYXSHMYQJXZTDPPBFYHZHTJYFDZWKGKZBLDNTSXHQEEGZZYLZMMZYJZGXZXKHKSTXNXXWYLYAPSTHXDWHZYMPXAGKYDXBHNHXKDPJNMYHYLPMGOCSLNZHKXXLPZZLBMLSFBHHGYGYYGGBHSCYAQTYWLXTZQCEZYDQDQMMHTKLLSZHLSJZWFYHQSWSCWLQAZYNYTLSXTHAZNKZZSZZLAXXZWWCTGQQTDDYZTCCHYQZFLXPSLZYGPZSZNGLNDQTBDLXGTCTAJDKYWNSYZLJHHZZCWNYYZYWMHYCHHYXHJKZWSXHZYXLYSKQYSPSLYZWMYPPKBYGLKZHTYXAXQSYSHXASMCHKDSCRSWJPWXSGZJLWWSCHSJHSQNHCSEGNDAQTBAALZZMSSTDQJCJKTSCJAXPLGGXHHGXXZCXPDMMHLDGTYBYSJMXHMRCPXXJZCKZXSHMLQXXTTHXWZFKHCCZDYTCJYXQHLXDHYPJQXYLSYYDZOZJNYXQEZYSQYAYXWYPDGXDDXSPPYZNDLTWRHXYDXZZJHTCXMCZLHPYYYYMHZLLHNXMYLLLMDCPPXHMXDKYCYRDLTXJCHHZZXZLCCLYLNZSHZJZZLNNRLWHYQSNJHXYNTTTKYJPYCHHYEGKCTTWLGQRLGGTGTYGYHPYHYLQYQGCWYQKPYYYTTTTLHYHLLTYTTSPLKYZXGZWGPYDSSZZDQXSKCQNMJJZZBXYQMJRTFFBTKHZKBXLJJKDXJTLBWFZPPTKQTZTGPDGNTPJYFALQMKGXBDCLZFHZCLLLLADPMXDJHLCCLGYHDZFGYDDGCYYFGYDXKSSEBDHYKDKDKHNAXXYBPBYYHXZQGAFFQYJXDMLJCSQZLLPCHBSXGJYNDYBYQSPZWJLZKSDDTACTBXZDYZYPJZQSJNKKTKNJDJGYYPGTLFYQKASDNTCYHBLWDZHBBYDWJRYGKZYHEYYFJMSDTYFZJJHGCXPLXHLDWXXJKYTCYKSSSMTWCTTQZLPBSZDZWZXGZAGYKTYWXLHLSPBCLLOQMMZSSLCMBJCSZZKYDCZJGQQDSMCYTZQQLWZQZXSSFPTTFQMDDZDSHDTDWFHTDYZJYQJQKYPBDJYYXTLJHDRQXXXHAYDHRJLKLYTWHLLRLLRCXYLBWSRSZZSYMKZZHHKYHXKSMDSYDYCJPBZBSQLFCXXXNXKXWYWSDZYQOGGQMMYHCDZTTFJYYBGSTTTYBYKJDHKYXBELHTYPJQNFXFDYKZHQKZBYJTZBXHFDXKDASWTAWAJLDYJSFHBLDNNTNQJTJNCHXFJSRFWHZFMDRYJYJWZPDJKZYJYMPCYZNYNXFBYTFYFWYGDBNZZZDNYTXZEMMQBSQEHXFZMBMFLZZSRXYMJGSXWZJSPRYDJSJGXHJJGLJJYNZZJXHGXKYMLPYYYCXYTWQZSWHWLYRJLPXSLSXMFSWWKLCTNXNYNPSJSZHDZEPTXMYYWXYYSYWLXJQZQXZDCLEEELMCPJPCLWBXSQHFWWTFFJTNQJHJQDXHWLBYZNFJLALKYYJLDXHHYCSTYYWNRJYXYWTRMDRQHWQCMFJDYZMHMYYXJWMYZQZXTLMRSPWWCHAQBXYGZYPXYYRRCLMPYMGKSJSZYSRMYJSNXTPLNBAPPYPYLXYYZKYNLDZYJZCZNNLMZHHARQMPGWQTZMXXMLLHGDZXYHXKYXYCJMFFYYHJFSBSSQLXXNDYCANNMTCJCYPRRNYTYQNYYMBMSXNDLYLYSLJRLXYSXQMLLYZLZJJJKYZZCSFBZXXMSTBJGNXYZHLXNMCWSCYZYFZLXBRNNNYLBNRTGZQYSATSWRYHYJZMZDHZGZDWYBSSCSKXSYHYTXXGCQGXZZSHYXJSCRHMKKBXCZJYJYMKQHZJFNBHMQHYSNJNZYBKNQMCLGQHWLZNZSWXKHLJHYYBQLBFCDSXDLDSPFZPSKJYZWZXZDDXJSMMEGJSCSSMGCLXXKYYYLNYPWWWGYDKZJGGGZGGSYCKNJWNJPCXBJJTQTJWDSSPJXZXNZXUMELPXFSXTLLXCLJXJJLJZXCTPSWXLYDHLYQRWHSYCSQYYBYAYWJJJQFWQCQQCJQGXALDBZZYJGKGXPLTZYFXJLTPADKYQHPMATLCPDCKBMTXYBHKLENXDLEEGQDYMSAWHZMLJTWYGXLYQZLJEEYYBQQFFNLYXRDSCTGJGXYYNKLLYQKCCTLHJLQMKKZGCYYGLLLJDZGYDHZWXPYSJBZKDZGYZZHYWYFQYTYZSZYEZZLYMHJJHTSMQWYZLKYYWZCSRKQYTLTDXWCTYJKLWSQZWBDCQYNCJSRSZJLKCDCDTLZZZACQQZZDDXYPLXZBQJYLZLLLQDDZQJYJYJZYXNYYYNYJXKXDAZWYRDLJYYYRJLXLLDYXJCYWYWNQCCLDDNYYYNYCKCZHXXCCLGZQJGKWPPCQQJYSBZZXYJSQPXJPZBSBDSFNSFPZXHDWZTDWPPTFLZZBZDMYYPQJRSDZSQZSQXBDGCPZSWDWCSQZGMDHZXMWWFYBPDGPHTMJTHZSMMBGZMBZJCFZWFZBBZMQCFMBDMCJXLGPNJBBXGYHYYJGPTZGZMQBQTCGYXJXLWZKYDPDYMGCFTPFXYZTZXDZXTGKMTYBBCLBJASKYTSSQYYMSZXFJEWLXLLSZBQJJJAKLYLXLYCCTSXMCWFKKKBSXLLLLJYXTYLTJYYTDPJHNHNNKBYQNFQYYZBYYESSESSGDYHFHWTCJBSDZZTFDMXHCNJZYMQWSRYJDZJQPDQBBSTJGGFBKJBXTGQHNGWJXJGDLLTHZHHYYYYYYSXWTYYYCCBDBPYPZYCCZYJPZYWCBDLFWZCWJDXXHYHLHWZZXJTCZLCDPXUJCZZZLYXJJTXPHFXWPYWXZPTDZZBDZCYHJHMLXBQXSBYLRDTGJRRCTTTHYTCZWMXFYTWWZCWJWXJYWCSKYBZSCCTZQNHXNWXXKHKFHTSWOCCJYBCMPZZYKBNNZPBZHHZDLSYDDYTYFJPXYNGFXBYQXCBHXCPSXTYZDMKYSNXSXLHKMZXLYHDHKWHXXSSKQYHHCJYXGLHZXCSNHEKDTGZXQYPKDHEXTYKCNYMYYYPKQYYYKXZLTHJQTBYQHXBMYHSQCKWWYLLHCYYLNNEQXQWMCFBDCCMLJGGXDQKTLXKGNQCDGZJWYJJLYHHQTTTNWCHMXCXWHWSZJYDJCCDBQCDGDNYXZTHCQRXCBHZTQCBXWGQWYYBXHMBYMYQTYEXMQKYAQYRGYZSLFYKKQHYSSQYSHJGJCNXKZYCXSBXYXHYYLSTYCXQTHYSMGSCPMMGCCCCCMTZTASMGQZJHKLOSQYLSWTMXSYQKDZLJQQYPLSYCZTCQQPBBQJZCLPKHQZYYXXDTDDTSJCXFFLLCHQXMJLWCJCXTSPYCXNDTJSHJWXDQQJSKXYAMYLSJHMLALYKXCYYDMNMDQMXMCZNNCYBZKKYFLMCHCMLHXRCJJHSYLNMTJZGZGYWJXSRXCWJGJQHQZDQJDCJJZKJKGDZQGJJYJYLXZXXCDQHHHEYTMHLFSBDJSYYSHFYSTCZQLPBDRFRZTZYKYWHSZYQKWDQZRKMSYNBCRXQBJYFAZPZZEDZCJYWBCJWHYJBQSZYWRYSZPTDKZPFPBNZTKLQYHBBZPNPPTYZZYBQNYDCPJMMCYCQMCYFZZDCMNLFPBPLNGQJTBTTNJZPZBBZNJKLJQYLNBZQHKSJZNGGQSZZKYXSHPZSNBCGZKDDZQANZHJKDRTLZLSWJLJZLYWTJNDJZJHXYAYNCBGTZCSSQMNJPJYTYSWXZFKWJQTKHTZPLBHSNJZSYZBWZZZZLSYLSBJHDWWQPSLMMFBJDWAQYZTCJTBNNWZXQXCDSLQGDSDPDZHJTQQPSWLYYJZLGYXYZLCTCBJTKTYCZJTQKBSJLGMGZDMCSGPYNJZYQYYKNXRPWSZXMTNCSZZYXYBYHYZAXYWQCJTLLCKJJTJHGDXDXYQYZZBYWDLWQCGLZGJGQRQZCZSSBCRPCSKYDZNXJSQGXSSJMYDNSTZTPBDLTKZWXQWQTZEXNQCZGWEZKSSBYBRTSSSLCCGBPSZQSZLCCGLLLZXHZQTHCZMQGYZQZNMCOCSZJMMZSQPJYGQLJYJPPLDXRGZYXCCSXHSHGTZNLZWZKJCXTCFCJXLBMQBCZZWPQDNHXLJCTHYZLGYLNLSZZPCXDSCQQHJQKSXZPBAJYEMSMJTZDXLCJYRYYNWJBNGZZTMJXLTBSLYRZPYLSSCNXPHLLHYLLQQZQLXYMRSYCXZLMMCZLTZSDWTJJLLNZGGQXPFSKYGYGHBFZPDKMWGHCXMSGDXJMCJZDYCABXJDLNBCDQYGSKYDQTXDJJYXMSZQAZDZFSLQXYJSJZYLBTXXWXQQZBJZUFBBLYLWDSLJHXJYZJWTDJCZFQZQZZDZSXZZQLZCDZFJHYSPYMPQZMLPPLFFXJJNZZYLSJEYQZFPFZKSYWJJJHRDJZZXTXXGLGHYDXCSKYSWMMZCWYBAZBJKSHFHJCXMHFQHYXXYZFTSJYZFXYXPZLCHMZMBXHZZSXYFYMNCWDABAZLXKTCSHHXKXJJZJSTHYGXSXYYHHHJWXKZXSSBZZWHHHCWTZZZPJXSNXQQJGZYZYWLLCWXZFXXYXYHXMKYYSWSQMNLNAYCYSPMJKHWCQHYLAJJMZXHMMCNZHBHXCLXTJPLTXYJHDYYLTTXFSZHYXXSJBJYAYRSMXYPLCKDUYHLXRLNLLSTYZYYQYGYHHSCCSMZCTZQXKYQFPYYRPFFLKQUNTSZLLZMWWTCQQYZWTLLMLMPWMBZSSTZRBPDDTLQJJBXZCSRZQQYGWCSXFWZLXCCRSZDZMCYGGDZQSGTJSWLJMYMMZYHFBJDGYXCCPSHXNZCSBSJYJGJMPPWAFFYFNXHYZXZYLREMZGZCYZSSZDLLJCSQFNXZKPTXZGXJJGFMYYYSNBTYLBNLHPFZDCYFBMGQRRSSSZXYSGTZRNYDZZCDGPJAFJFZKNZBLCZSZPSGCYCJSZLMLRSZBZZLDLSLLYSXSQZQLYXZLSKKBRXBRBZCYCXZZZEEYFGKLZLYYHGZSGZLFJHGTGWKRAAJYZKZQTSSHJJXDCYZUYJLZYRZDQQHGJZXSSZBYKJPBFRTJXLLFQWJHYLQTYMBLPZDXTZYGBDHZZRBGXHWNJTJXLKSCFSMWLSDQYSJTXKZSCFWJLBXFTZLLJZLLQBLSQMQQCGCZFPBPHZCZJLPYYGGDTGWDCFCZQYYYQYSSCLXZSKLZZZGFFCQNWGLHQYZJJCZLQZZYJPJZZBPDCCMHJGXDQDGDLZQMFGPSYTSDYFWWDJZJYSXYYCZCYHZWPBYKXRYLYBHKJKSFXTZJMMCKHLLTNYYMSYXYZPYJQYCSYCWMTJJKQYRHLLQXPSGTLYYCLJSCPXJYZFNMLRGJJTYZBXYZMSJYJHHFZQMSYXRSZCWTLRTQZSSTKXGQKGSPTGCZNJSJCQCXHMXGGZTQYDJKZDLBZSXJLHYQGGGTHQSZPYHJHHGYYGKGGCWJZZYLCZLXQSFTGZSLLLMLJSKCTBLLZZSZMMNYTPZSXQHJCJYQXYZXZQZCPSHKZZYSXCDFGMWQRLLQXRFZTLYSTCTMJCXJJXHJNXTNRZTZFQYHQGLLGCXSZSJDJLJCYDSJTLNYXHSZXCGJZYQPYLFHDJSBPCCZHJJJQZJQDYBSSLLCMYTTMQTBHJQNNYGKYRQYQMZGCJKPDCGMYZHQLLSLLCLMHOLZGDYYFZSLJCQZLYLZQJESHNYLLJXGJXLYSYYYXNBZLJSSZCQQCJYLLZLTJYLLZLLBNYLGQCHXYYXOXCXQKYJXXXYKLXSXXYQXCYKQXQCSGYXXYQXYGYTQOHXHXPYXXXULCYEYCHZZCBWQBBWJQZSCSZSSLZYLKDESJZWMYMCYTSDSXXSCJPQQSQYLYYZYCMDJDZYWCBTJSYDJKCYDDJLBDJJSODZYSYXQQYXDHHGQQYQHDYXWGMMMAJDYBBBPPBCMUUPLJZSMTXERXJMHQNUTPJDCBSSMSSSTKJTSSMMTRCPLZSZMLQDSDMJMQPNQDXCFYNBFSDQXYXHYAYKQYDDLQYYYSSZBYDSLNTFQTZQPZMCHDHCZCWFDXTMYQSPHQYYXSRGJCWTJTZZQMGWJJTJHTQJBBHWZPXXHYQFXXQYWYYHYSCDYDHHQMNMTMWCPBSZPPZZGLMZFOLLCFWHMMSJZTTDHZZYFFYTZZGZYSKYJXQYJZQBHMBZZLYGHGFMSHPZFZSNCLPBQSNJXZSLXXFPMTYJYGBXLLDLXPZJYZJYHHZCYWHJYLSJEXFSZZYWXKZJLUYDTMLYMQJPWXYHXSKTQJEZRPXXZHHMHWQPWQLYJJQJJZSZCPHJLCHHNXJLQWZJHBMZYXBDHHYPZLHLHLGFWLCHYYTLHJXCJMSCPXSTKPNHQXSRTYXXTESYJCTLSSLSTDLLLWWYHDHRJZSFGXTSYCZYNYHTDHWJSLHTZDQDJZXXQHGYLTZPHCSQFCLNJTCLZPFSTPDYNYLGMJLLYCQHYSSHCHYLHQYQTMZYPBYWRFQYKQSYSLZDQJMPXYYSSRHZJNYWTQDFZBWWTWWRXCWHGYHXMKMYYYQMSMZHNGCEPMLQQMTCWCTMMPXJPJJHFXYYZSXZHTYBMSTSYJTTQQQYYLHYNPYQZLCYZHZWSMYLKFJXLWGXYPJYTYSYXYMZCKTTWLKSMZSYLMPWLZWXWQZSSAQSYXYRHSSNTSRAPXCPWCMGDXHXZDZYFJHGZTTSBJHGYZSZYSMYCLLLXBTYXHBBZJKSSDMALXHYCFYGMQYPJYCQXJLLLJGSLZGQLYCJCCZOTYXMTMTTLLWTGPXYMZMKLPSZZZXHKQYSXCTYJZYHXSHYXZKXLZWPSQPYHJWPJPWXQQYLXSDHMRSLZZYZWTTCYXYSZZSHBSCCSTPLWSSCJCHNLCGCHSSPHYLHFHHXJSXYLLNYLSZDHZXYLSXLWZYKCLDYAXZCMDDYSPJTQJZLNWQPSSSWCTSTSZLBLNXSMNYYMJQBQHRZWTYYDCHQLXKPZWBGQYBKFCMZWPZLLYYLSZYDWHXPSBCMLJBSCGBHXLQHYRLJXYSWXWXZSLDFHLSLYNJLZYFLYJYCDRJLFSYZFSLLCQYQFGJYHYXZLYLMSTDJCYHBZLLNWLXXYGYYHSMGDHXXHHLZZJZXCZZZCYQZFNGWPYLCPKPYYPMCLQKDGXZGGWQBDXZZKZFBXXLZXJTPJPTTBYTSZZDWSLCHZHSLTYXHQLHYXXXYYZYSWTXZKHLXZXZPYHGCHKCFSYHUTJRLXFJXPTZTWHPLYXFCRHXSHXKYXXYHZQDXQWULHYHMJTBFLKHTXCWHJFWJCFPQRYQXCYYYQYGRPYWSGSUNGWCHKZDXYFLXXHJJBYZWTSXXNCYJJYMSWZJQRMHXZWFQSYLZJZGBHYNSLBGTTCSYBYXXWXYHXYYXNSQYXMQYWRGYQLXBBZLJSYLPSYTJZYHYZAWLRORJMKSCZJXXXYXCHDYXRYXXJDTSQFXLYLTSFFYXLMTYJMJUYYYXLTZCSXQZQHZXLYYXZHDNBRXXXJCTYHLBRLMBRLLAXKYLLLJLYXXLYCRYLCJTGJCMTLZLLCYZZPZPCYAWHJJFYBDYYZSMPCKZDQYQPBPCJPDCYZMDPBCYYDYCNNPLMTMLRMFMMGWYZBSJGYGSMZQQQZTXMKQWGXLLPJGZBQCDJJJFPKJKCXBLJMSWMDTQJXLDLPPBXCWRCQFBFQJCZAHZGMYKPHYYHZYKNDKZMBPJYXPXYHLFPNYYGXJDBKXNXHJMZJXSTRSTLDXSKZYSYBZXJLXYSLBZYSLHXJPFXPQNBYLLJQKYGZMCYZZYMCCSLCLHZFWFWYXZMWSXTYNXJHPYYMCYSPMHYSMYDYSHQYZCHMJJMZCAAGCFJBBHPLYZYLXXSDJGXDHKXXTXXNBHRMLYJSLTXMRHNLXQJXYZLLYSWQGDLBJHDCGJYQYCMHWFMJYBMBYJYJWYMDPWHXQLDYGPDFXXBCGJSPCKRSSYZJMSLBZZJFLJJJLGXZGYXYXLSZQYXBEXYXHGCXBPLDYHWETTWWCJMBTXCHXYQXLLXFLYXLLJLSSFWDPZSMYJCLMWYTCZPCHQEKCQBWLCQYDPLQPPQZQFJQDJHYMMCXTXDRMJWRHXCJZYLQXDYYNHYYHRSLSRSYWWZJYMTLTLLGTQCJZYABTCKZCJYCCQLJZQXALMZYHYWLWDXZXQDLLQSHGPJFJLJHJABCQZDJGTKHSSTCYJLPSWZLXZXRWGLDLZRLZXTGSLLLLZLYXXWGDZYGBDPHZPBRLWSXQBPFDWOFMWHLYPCBJCCLDMBZPBZZLCYQXLDOMZBLZWPDWYYGDSTTHCSQSCCRSSSYSLFYBFNTYJSZDFNDPDHDZZMBBLSLCMYFFGTJJQWFTMTPJWFNLBZCMMJTGBDZLQLPYFHYYMJYLSDCHDZJWJCCTLJCLDTLJJCPDDSQDSSZYBNDBJLGGJZXSXNLYCYBJXQYCBYLZCFZPPGKCXZDZFZTJJFJSJXZBNZYJQTTYJYHTYCZHYMDJXTTMPXSPLZCDWSLSHXYPZGTFMLCJTYCBPMGDKWYCYZCDSZZYHFLYCTYGWHKJYYLSJCXGYWJCBLLCSNDDBTZBSCLYZCZZSSQDLLMQYYHFSLQLLXFTYHABXGWNYWYYPLLSDLDLLBJCYXJZMLHLJDXYYQYTDLLLBUGBFDFBBQJZZMDPJHGCLGMJJPGAEHHBWCQXAXHHHZCHXYPHJAXHLPHJPGPZJQCQZGJJZZUZDMQYYBZZPHYHYBWHAZYJHYKFGDPFQSDLZMLJXKXGALXZDAGLMDGXMWZQYXXDXXPFDMMSSYMPFMDMMKXKSYZYSHDZKXSYSMMZZZMSYDNZZCZXFPLSTMZDNMXCKJMZTYYMZMZZMSXHHDCZJEMXXKLJSTLWLSQLYJZLLZJSSDPPMHNLZJCZYHMXXHGZCJMDHXTKGRMXFWMCGMWKDTKSXQMMMFZZYDKMSCLCMPCGMHSPXQPZDSSLCXKYXTWLWJYAHZJGZQMCSNXYYMMPMLKJXMHLMLQMXCTKZMJQYSZJSYSZHSYJZJCDAJZYBSDQJZGWZQQXFKDMSDJLFWEHKZQKJPEYPZYSZCDWYJFFMZZYLTTDZZEFMZLBNPPLPLPEPSZALLTYLKCKQZKGENQLWAGYXYDPXLHSXQQWQCQXQCLHYXXMLYCCWLYMQYSKGCHLCJNSZKPYZKCQZQLJPDMDZHLASXLBYDWQLWDNBQCRYDDZTJYBKBWSZDXDTNPJDTCTQDFXQQMGNXECLTTBKPWSLCTYQLPWYZZKLPYGZCQQPLLKCCYLPQMZCZQCLJSLQZDJXLDDHPZQDLJJXZQDXYZQKZLJCYQDYJPPYPQYKJYRMPCBYMCXKLLZLLFQPYLLLMBSGLCYSSLRSYSQTMXYXZQZFDZUYSYZTFFMZZSMZQHZSSCCMLYXWTPZGXZJGZGSJSGKDDHTQGGZLLBJDZLCBCHYXYZHZFYWXYZYMSDBZZYJGTSMTFXQYXQSTDGSLNXDLRYZZLRYYLXQHTXSRTZNGZXBNQQZFMYKMZJBZYMKBPNLYZPBLMCNQYZZZSJZHJCTZKHYZZJRDYZHNPXGLFZTLKGJTCTSSYLLGZRZBBQZZKLPKLCZYSSUYXBJFPNJZZXCDWXZYJXZZDJJKGGRSRJKMSMZJLSJYWQSKYHQJSXPJZZZLSNSHRNYPZTWCHKLPSRZLZXYJQXQKYSJYCZTLQZYBBYBWZPQDWWYZCYTJCJXCKCWDKKZXSGKDZXWWYYJQYYTCYTDLLXWKCZKKLCCLZCQQDZLQLCSFQCHQHSFSMQZZLNBJJZBSJHTSZDYSJQJPDLZCDCWJKJZZLPYCGMZWDJJBSJQZSYZYHHXJPBJYDSSXDZNCGLQMBTSFSBPDZDLZNFGFJGFSMPXJQLMBLGQCYYXBQKDJJQYRFKZTJDHCZKLBSDZCFJTPLLJGXHYXZCSSZZXSTJYGKGCKGYOQXJPLZPBPGTGYJZGHZQZZLBJLSQFZGKQQJZGYCZBZQTLDXRJXBSXXPZXHYZYCLWDXJJHXMFDZPFZHQHQMQGKSLYHTYCGFRZGNQXCLPDLBZCSCZQLLJBLHBZCYPZZPPDYMZZSGYHCKCPZJGSLJLNSCDSLDLXBMSTLDDFJMKDJDHZLZXLSZQPQPGJLLYBDSZGQLBZLSLKYYHZTTNTJYQTZZPSZQZTLLJTYYLLQLLQYZQLBDZLSLYYZYMDFSZSNHLXZNCZQZPBWSKRFBSYZMTHBLGJPMCZZLSTLXSHTCSYZLZBLFEQHLXFLCJLYLJQCBZLZJHHSSTBRMHXZHJZCLXFNBGXGTQJCZTMSFZKJMSSNXLJKBHSJXNTNLZDNTLMSJXGZJYJCZXYJYJWRWWQNZTNFJSZPZSHZJFYRDJSFSZJZBJFZQZZHZLXFYSBZQLZSGYFTZDCSZXZJBQMSZKJRHYJZCKMJKHCHGTXKXQGLXPXFXTRTYLXJXHDTSJXHJZJXZWZLCQSBTXWXGXTXXHXFTSDKFJHZYJFJXRZSDLLLTQSQQZQWZXSYQTWGWBZCGZLLYZBCLMQQTZHZXZXLJFRMYZFLXYSQXXJKXRMQDZDMMYYBSQBHGZMWFWXGMXLZPYYTGZYCCDXYZXYWGSYJYZNBHPZJSQSYXSXRTFYZGRHZTXSZZTHCBFCLSYXZLZQMZLMPLMXZJXSFLBYZMYQHXJSXRXSQZZZSSLYFRCZJRCRXHHZXQYDYHXSJJHZCXZBTYNSYSXJBQLPXZQPYMLXZKYXLXCJLCYSXXZZLXDLLLJJYHZXGYJWKJRWYHCPSGNRZLFZWFZZNSXGXFLZSXZZZBFCSYJDBRJKRDHHGXJLJJTGXJXXSTJTJXLYXQFCSGSWMSBCTLQZZWLZZKXJMLTMJYHSDDBXGZHDLBMYJFRZFSGCLYJBPMLYSMSXLSZJQQHJZFXGFQFQBPXZGYYQXGZTCQWYLTLGWSGWHRLFSFGZJMGMGBGTJFSYZZGZYZAFLSSPMLPFLCWBJZCLJJMZLPJJLYMQDMYYYFBGYGYZMLYZDXQYXRQQQHSYYYQXYLJTYXFSFSLLGNQCYHYCWFHCCCFXPYLYPLLZYXXXXXKQHHXSHJZCFZSCZJXCPZWHHHHHAPYLQALPQAFYHXDYLUKMZQGGGDDESRNNZLTZGCHYPPYSQJJHCLLJTOLNJPZLJLHYMHEYDYDSQYCDDHGZUNDZCLZYZLLZNTNYZGSLHSLPJJBDGWXPCDUTJCKLKCLWKLLCASSTKZZDNQNTTLYYZSSYSSZZRYLJQKCQDHHCRXRZYDGRGCWCGZQFFFPPJFZYNAKRGYWYQPQXXFKJTSZZXSWZDDFBBXTBGTZKZNPZZPZXZPJSZBMQHKCYXYLDKLJNYPKYGHGDZJXXEAHPNZKZTZCMXCXMMJXNKSZQNMNLWBWWXJKYHCPSTMCSQTZJYXTPCTPDTNNPGLLLZSJLSPBLPLQHDTNJNLYYRSZFFJFQWDPHZDWMRZCCLODAXNSSNYZRESTYJWJYJDBCFXNMWTTBYLWSTSZGYBLJPXGLBOCLHPCBJLTMXZLJYLZXCLTPNCLCKXTPZJSWCYXSFYSZDKNTLBYJCYJLLSTGQCBXRYZXBXKLYLHZLQZLNZCXWJZLJZJNCJHXMNZZGJZZXTZJXYCYYCXXJYYXJJXSSSJSTSSTTPPGQTCSXWZDCSYFPTFBFHFBBLZJCLZZDBXGCXLQPXKFZFLSYLTUWBMQJHSZBMDDBCYSCCLDXYCDDQLYJJWMQLLCSGLJJSYFPYYCCYLTJANTJJPWYCMMGQYYSXDXQMZHSZXPFTWWZQSWQRFKJLZJQQYFBRXJHHFWJJZYQAZMYFRHCYYBYQWLPEXCCZSTYRLTTDMQLYKMBBGMYYJPRKZNPBSXYXBHYZDJDNGHPMFSGMWFZMFQMMBCMZZCJJLCNUXYQLMLRYGQZCYXZLWJGCJCGGMCJNFYZZJHYCPRRCMTZQZXHFQGTJXCCJEAQCRJYHPLQLSZDJRBCQHQDYRHYLYXJSYMHZYDWLDFRYHBPYDTSSCNWBXGLPZMLZZTQSSCPJMXXYCSJYTYCGHYCJWYRXXLFEMWJNMKLLSWTXHYYYNCMMCWJDQDJZGLLJWJRKHPZGGFLCCSCZMCBLTBHBQJXQDSPDJZZGKGLFQYWBZYZJLTSTDHQHCTCBCHFLQMPWDSHYYTQWCNZZJTLBYMBPDYYYXSQKXWYYFLXXNCWCXYPMAELYKKJMZZZBRXYYQJFLJPFHHHYTZZXSGQQMHSPGDZQWBWPJHZJDYSCQWZKTXXSQLZYYMYSDZGRXCKKUJLWPYSYSCSYZLRMLQSYLJXBCXTLWDQZPCYCYKPPPNSXFYZJJRCEMHSZMSXLXGLRWGCSTLRSXBZGBZGZTCPLUJLSLYLYMTXMTZPALZXPXJTJWTCYYZLBLXBZLQMYLXPGHDSLSSDMXMBDZZSXWHAMLCZCPJMCNHJYSNSYGCHSKQMZZQDLLKABLWJXSFMOCDXJRRLYQZKJMYBYQLYHETFJZFRFKSRYXFJTWDSXXSYSQJYSLYXWJHSNLXYYXHBHAWHHJZXWMYLJCSSLKYDZTXBZSYFDXGXZJKHSXXYBSSXDPYNZWRPTQZCZENYGCXQFJYKJBZMLJCMQQXUOXSLYXXLYLLJDZBTYMHPFSTTQQWLHOKYBLZZALZXQLHZWRRQHLSTMYPYXJJXMQSJFNBXYXYJXXYQYLTHYLQYFMLKLJTMLLHSZWKZHLJMLHLJKLJSTLQXYLMBHHLNLZXQJHXCFXXLHYHJJGBYZZKBXSCQDJQDSUJZYYHZHHMGSXCSYMXFEBCQWWRBPYYJQTYZCYQYQQZYHMWFFHGZFRJFCDPXNTQYZPDYKHJLFRZXPPXZDBBGZQSTLGDGYLCQMLCHHMFYWLZYXKJLYPQHSYWMQQGQZMLZJNSQXJQSYJYCBEHSXFSZPXZWFLLBCYYJDYTDTHWZSFJMQQYJLMQXXLLDTTKHHYBFPWTYYSQQWNQWLGWDEBZWCMYGCULKJXTMXMYJSXHYBRWFYMWFRXYQMXYSZTZZTFYKMLDHQDXWYYNLCRYJBLPSXCXYWLSPRRJWXHQYPHTYDNXHHMMYWYTZCSQMTSSCCDALWZTCPQPYJLLQZYJSWXMZZMMYLMXCLMXCZMXMZSQTZPPQQBLPGXQZHFLJJHYTJSRXWZXSCCDLXTYJDCQJXSLQYCLZXLZZXMXQRJMHRHZJBHMFLJLMLCLQNLDXZLLLPYPSYJYSXCQQDCMQJZZXHNPNXZMEKMXHYKYQLXSXTXJYYHWDCWDZHQYYBGYBCYSCFGPSJNZDYZZJZXRZRQJJYMCANYRJTLDPPYZBSTJKXXZYPFDWFGZZRPYMTNGXZQBYXNBUFNQKRJQZMJEGRZGYCLKXZDSKKNSXKCLJSPJYYZLQQJYBZSSQLLLKJXTBKTYLCCDDBLSPPFYLGYDTZJYQGGKQTTFZXBDKTYYHYBBFYTYYBCLPDYTGDHRYRNJSPTCSNYJQHKLLLZSLYDXXWBCJQSPXBPJZJCJDZFFXXBRMLAZHCSNDLBJDSZBLPRZTSWSBXBCLLXXLZDJZSJPYLYXXYFTFFFBHJJXGBYXJPMMMPSSJZJMTLYZJXSWXTYLEDQPJMYGQZJGDJLQJWJQLLSJGJGYGMSCLJJXDTYGJQJQJCJZCJGDZZSXQGSJGGCXHQXSNQLZZBXHSGZXCXYLJXYXYYDFQQJHJFXDHCTXJYRXYSQTJXYEFYYSSYYJXNCYZXFXMSYSZXYYSCHSHXZZZGZZZGFJDLTYLNPZGYJYZYYQZPBXQBDZTZCZYXXYHHSQXSHDHGQHJHGYWSZTMZMLHYXGEBTYLZKQWYTJZRCLEKYSTDBCYKQQSAYXCJXWWGSBHJYZYDHCSJKQCXSWXFLTYNYZPZCCZJQTZWJQDZZZQZLJJXLSBHPYXXPSXSHHEZTXFPTLQYZZXHYTXNCFZYYHXGNXMYWXTZSJPTHHGYMXMXQZXTSBCZYJYXXTYYZYPCQLMMSZMJZZLLZXGXZAAJZYXJMZXWDXZSXZDZXLEYJJZQBHZWZZZQTZPSXZTDSXJJJZNYAZPHXYYSRNQDTHZHYYKYJHDZXZLSWCLYBZYECWCYCRYLCXNHZYDZYDYJDFRJJHTRSQTXYXJRJHOJYNXELXSFSFJZGHPZSXZSZDZCQZBYYKLSGSJHCZSHDGQGXYZGXCHXZJWYQWGYHKSSEQZZNDZFKWYSSTCLZSTSYMCDHJXXYWEYXCZAYDMPXMDSXYBSQMJMZJMTZQLPJYQZCGQHXJHHLXXHLHDLDJQCLDWBSXFZZYYSCHTYTYYBHECXHYKGJPXHHYZJFXHWHBDZFYZBCAPNPGNYDMSXHMMMMAMYNBYJTMPXYYMCTHJBZYFCGTYHWPHFTWZZEZSBZEGPFMTSKFTYCMHFLLHGPZJXZJGZJYXZSBBQSCZZLZCCSTPGXMJSFTCCZJZDJXCYBZLFCJSYZFGSZLYBCWZZBYZDZYPSWYJZXZBDSYUXLZZBZFYGCZXBZHZFTPBGZGEJBSTGKDMFHYZZJHZLLZZGJQZLSFDJSSCBZGPDLFZFZSZYZYZSYGCXSNXXCHCZXTZZLJFZGQSQYXZJQDCCZTQCDXZJYQJQCHXZTDLGSCXZSYQJQTZWLQDQZTQCHQQJZYEZZZPBWKDJFCJPZTYPQYQTTYNLMBDKTJZPQZQZZFPZSBNJLGYJDXJDZZKZGQKXDLPZJTCJDQBXDJQJSTCKNXBXZMSLYJCQMTJQWWCJQNJNLLLHJCWQTBZQYDZCZPZZDZYDDCYZZZCCJTTJFZDPRRTZTJDCQTQZDTJNPLZBCLLCTZSXKJZQZPZLBZRBTJDCXFCZDBCCJJLTQQPLDCGZDBBZJCQDCJWYNLLZYZCCDWLLXWZLXRXNTQQCZXKQLSGDFQTDDGLRLAJJTKUYMKQLLTZYTDYYCZGJWYXDXFRSKSTQTENQMRKQZHHQKDLDAZFKYPBGGPZREBZZYKZZSPEGJXGYKQZZZSLYSYYYZWFQZYLZZLZHWCHKYPQGNPGBLPLRRJYXCCSYYHSFZFYBZYYTGZXYLXCZWXXZJZBLFFLGSKHYJZEYJHLPLLLLCZGXDRZELRHGKLZZYHZLYQSZZJZQLJZFLNBHGWLCZCFJYSPYXZLZLXGCCPZBLLCYBBBBUBBCBPCRNNZCZYRBFSRLDCGQYYQXYGMQZWTZYTYJXYFWTEHZZJYWLCCNTZYJJZDEDPZDZTSYQJHDYMBJNYJZLXTSSTPHNDJXXBYXQTZQDDTJTDYYTGWSCSZQFLSHLGLBCZPHDLYZJYCKWTYTYLBNYTSDSYCCTYSZYYEBHEXHQDTWNYGYCLXTSZYSTQMYGZAZCCSZZDSLZCLZRQXYYELJSBYMXSXZTEMBBLLYYLLYTDQYSHYMRQWKFKBFXNXSBYCHXBWJYHTQBPBSBWDZYLKGZSKYHXQZJXHXJXGNLJKZLYYCDXLFYFGHLJGJYBXQLYBXQPQGZTZPLNCYPXDJYQYDYMRBESJYYHKXXSTMXRCZZYWXYQYBMCLLYZHQYZWQXDBXBZWZMSLPDMYSKFMZKLZCYQYCZLQXFZZYDQZPZYGYJYZMZXDZFYFYTTQTZHGSPCZMLCCYTZXJCYTJMKSLPZHYSNZLLYTPZCTZZCKTXDHXXTQCYFKSMQCCYYAZHTJPCYLZLYJBJXTPNYLJYYNRXSYLMMNXJSMYBCSYSYLZYLXJJQYLDZLPQBFZZBLFNDXQKCZFYWHGQMRDSXYCYTXNQQJZYYPFZXDYZFPRXEJDGYQBXRCNFYYQPGHYJDYZXGRHTKYLNWDZNTSMPKLBTHBPYSZBZTJZSZZJTYYXZPHSSZZBZCZPTQFZMYFLYPYBBJQXZMXXDJMTSYSKKBJZXHJCKLPSMKYJZCXTMLJYXRZZQSLXXQPYZXMKYXXXJCLJPRMYYGADYSKQLSNDHYZKQXZYZTCGHZTLMLWZYBWSYCTBHJHJFCWZTXWYTKZLXQSHLYJZJXTMPLPYCGLTBZZTLZJCYJGDTCLKLPLLQPJMZPAPXYZLKKTKDZCZZBNZDYDYQZJYJGMCTXLTGXSZLMLHBGLKFWNWZHDXUHLFMKYSLGXDTWWFRJEJZTZHYDXYKSHWFZCQSHKTMQQHTZHYMJDJSKHXZJZBZZXYMPAGQMSTPXLSKLZYNWRTSQLSZBPSPSGZWYHTLKSSSWHZZLYYTNXJGMJSZSUFWNLSOZTXGXLSAMMLBWLDSZYLAKQCQCTMYCFJBSLXCLZZCLXXKSBZQCLHJPSQPLSXXCKSLNHPSFQQYTXYJZLQLDXZQJZDYYDJNZPTUZDSKJFSLJHYLZSQZLBTXYDGTQFDBYAZXDZHZJNHHQBYKNXJJQCZMLLJZKSPLDYCLBBLXKLELXJLBQYCXJXGCNLCQPLZLZYJTZLJGYZDZPLTQCSXFDMNYCXGBTJDCZNBGBQYQJWGKFHTNPYQZQGBKPBBYZMTJDYTBLSQMPSXTBNPDXKLEMYYCJYNZCTLDYKZZXDDXHQSHDGMZSJYCCTAYRZLPYLTLKXSLZCGGEXCLFXLKJRTLQJAQZNCMBYDKKCXGLCZJZXJHPTDJJMZQYKQSECQZDSHHADMLZFMMZBGNTJNNLGBYJBRBTMLBYJDZXLCJLPLDLPCQDHLXZLYCBLCXZZJADJLNZMMSSSMYBHBSQKBHRSXXJMXSDZNZPXLGBRHWGGFCXGMSKLLTSJYYCQLTSKYWYYHYWXBXQYWPYWYKQLSQPTNTKHQCWDQKTWPXXHCPTHTWUMSSYHBWCRWXHJMKMZNGWTMLKFGHKJYLSYYCXWHYECLQHKQHTTQKHFZLDXQWYZYYDESBPKYRZPJFYYZJCEQDZZDLATZBBFJLLCXDLMJSSXEGYGSJQXCWBXSSZPDYZCXDNYXPPZYDLYJCZPLTXLSXYZYRXCYYYDYLWWNZSAHJSYQYHGYWWAXTJZDAXYSRLTDPSSYYFNEJDXYZHLXLLLZQZSJNYQYQQXYJGHZGZCYJCHZLYCDSHWSHJZYJXCLLNXZJJYYXNFXMWFPYLCYLLABWDDHWDXJMCXZTZPMLQZHSFHZYNZTLLDYWLSLXHYMMYLMBWWKYXYADTXYLLDJPYBPWUXJMWMLLSAFDLLYFLBHHHBQQLTZJCQJLDJTFFKMMMBYTHYGDCQRDDWRQJXNBYSNWZDBYYTBJHPYBYTTJXAAHGQDQTMYSTQXKBTZPKJLZRBEQQSSMJJBDJOTGTBXPGBKTLHQXJJJCTHXQDWJLWRFWQGWSHCKRYSWGFTGYGBXSDWDWRFHWYTJJXXXJYZYSLPYYYPAYXHYDQKXSHXYXGSKQHYWFDDDPPLCJLQQEEWXKSYYKDYPLTJTHKJLTCYYHHJTTPLTZZCDLTHQKZXQYSTEEYWYYZYXXYYSTTJKLLPZMCYHQGXYHSRMBXPLLNQYDQHXSXXWGDQBSHYLLPJJJTHYJKYPPTHYYKTYEZYENMDSHLCRPQFDGFXZPSFTLJXXJBSWYYSKSFLXLPPLBBBLBSFXFYZBSJSSYLPBBFFFFSSCJDSTZSXZRYYSYFFSYZYZBJTBCTSBSDHRTJJBYTCXYJEYLXCBNEBJDSYXYKGSJZBXBYTFZWGENYHHTHZHHXFWGCSTBGXKLSXYWMTMBYXJSTZSCDYQRCYTWXZFHMYMCXLZNSDJTTTXRYCFYJSBSDYERXJLJXBBDEYNJGHXGCKGSCYMBLXJMSZNSKGXFBNBPTHFJAAFXYXFPXMYPQDTZCXZZPXRSYWZDLYBBKTYQPQJPZYPZJZNJPZJLZZFYSBTTSLMPTZRTDXQSJEHBZYLZDHLJSQMLHTXTJECXSLZZSPKTLZKQQYFSYGYWPCPQFHQHYTQXZKRSGTTSQCZLPTXCDYYZXSQZSLXLZMYCPCQBZYXHBSXLZDLTCDXTYLZJYYZPZYZLTXJSJXHLPMYTXCQRBLZSSFJZZTNJYTXMYJHLHPPLCYXQJQQKZZSCPZKSWALQSBLCCZJSXGWWWYGYKTJBBZTDKHXHKGTGPBKQYSLPXPJCKBMLLXDZSTBKLGGQKQLSBKKTFXRMDKBFTPZFRTBBRFERQGXYJPZSSTLBZTPSZQZSJDHLJQLZBPMSMMSXLQQNHKNBLRDDNXXDHDDJCYYGYLXGZLXSYGMQQGKHBPMXYXLYTQWLWGCPBMQXCYZYDRJBHTDJYHQSHTMJSBYPLWHLZFFNYPMHXXHPLTBQPFBJWQDBYGPNZTPFZJGSDDTQSHZEAWZZYLLTYYBWJKXXGHLFKXDJTMSZSQYNZGGSWQSPHTLSSKMCLZXYSZQZXNCJDQGZDLFNYKLJCJLLZLMZZNHYDSSHTHZZLZZBBHQZWWYCRZHLYQQJBEYFXXXWHSRXWQHWPSLMSSKZTTYGYQQWRSLALHMJTQJSMXQBJJZJXZYZKXBYQXBJXSHZTSFJLXMXZXFGHKZSZGGYLCLSARJYHSLLLMZXELGLXYDJYTLFBHBPNLYZFBBHPTGJKWETZHKJJXZXXGLLJLSTGSHJJYQLQZFKCGNNDJSSZFDBCTWWSEQFHQJBSAQTGYPQLBXBMMYWXGSLZHGLZGQYFLZBYFZJFRYSFMBYZHQGFWZSYFYJJPHZBYYZFFWODGRLMFTWLBZGYCQXCDJYGZYYYYTYTYDWEGAZYHXJLZYYHLRMGRXXZCLHNELJJTJTPWJYBJJBXJJTJTEEKHWSLJPLPSFYZPQQBDLQJJTYYQLYZKDKSQJYYQZLDQTGJQYZJSUCMRYQTHTEJMFCTYHYPKMHYZWJDQFHYYXWSHCTXRLJHQXHCCYYYJLTKTTYTMXGTCJTZAYYOCZLYLBSZYWJYTSJYHBYSHFJLYGJXXTMZYYLTXXYPZLXYJZYZYYPNHMYMDYYLBLHLSYYQQLLNJJYMSOYQBZGDLYXYLCQYXTSZEGXHZGLHWBLJHEYXTWQMAKBPQCGYSHHEGQCMWYYWLJYJHYYZLLJJYLHZYHMGSLJLJXCJJYCLYCJPCPZJZJMMYLCQLNQLJQJSXYJMLSZLJQLYCMMHCFMMFPQQMFYLQMCFFQMMMMHMZNFHHJGTTHHKHSLNCHHYQDXTMMQDCYZYXYQMYQYLTDCYYYZAZZCYMZYDLZFFFMMYCQZWZZMABTBYZTDMNZZGGDFTYPCGQYTTSSFFWFDTZQSSYSTWXJHXYTSXXYLBYQHWWKXHZXWZNNZZJZJJQJCCCHYYXBZXZCYZTLLCQXYNJYCYYCYNZZQYYYEWYCZDCJYCCHYJLBTZYYCQWMPWPYMLGKDLDLGKQQBGYCHJXY'
    //此处收录了375个多音字,数据来自于http://www.51window.net/page/pinyin
    const oMultiDiff = {
        19969: 'DZ',
        19975: 'WM',
        19988: 'QJ',
        20048: 'YL',
        20056: 'SC',
        20060: 'NM',
        20094: 'QG',
        20127: 'QJ',
        20167: 'QC',
        20193: 'YG',
        20250: 'KH',
        20256: 'ZC',
        20282: 'SC',
        20285: 'QJG',
        20291: 'TD',
        20314: 'YD',
        20340: 'NE',
        20375: 'TD',
        20389: 'YJ',
        20391: 'CZ',
        20415: 'PB',
        20446: 'YS',
        20447: 'SQ',
        20504: 'TC',
        20608: 'KG',
        20854: 'QJ',
        20857: 'ZC',
        20911: 'PF',
        20985: 'AW',
        21032: 'PB',
        21048: 'XQ',
        21049: 'SC',
        21089: 'YS',
        21119: 'JC',
        21242: 'SB',
        21273: 'SC',
        21305: 'YP',
        21306: 'QO',
        21330: 'ZC',
        21333: 'SDC',
        21345: 'QK',
        21378: 'CA',
        21397: 'SC',
        21414: 'XS',
        21442: 'SC',
        21477: 'JG',
        21480: 'TD',
        21484: 'ZS',
        21494: 'YX',
        21505: 'YX',
        21512: 'HG',
        21523: 'XH',
        21537: 'PB',
        21542: 'PF',
        21549: 'KH',
        21571: 'E',
        21574: 'DA',
        21588: 'TD',
        21589: 'O',
        21618: 'ZC',
        21621: 'KHA',
        21632: 'ZJ',
        21654: 'KG',
        21679: 'LKG',
        21683: 'KH',
        21710: 'A',
        21719: 'YH',
        21734: 'WOE',
        21769: 'A',
        21780: 'WN',
        21804: 'XH',
        21834: 'A',
        21899: 'ZD',
        21903: 'RN',
        21908: 'WO',
        21939: 'ZC',
        21956: 'SA',
        21964: 'YA',
        21970: 'TD',
        22003: 'A',
        22031: 'JG',
        22040: 'XS',
        22060: 'ZC',
        22066: 'ZC',
        22079: 'MH',
        22129: 'XJ',
        22179: 'XA',
        22237: 'NJ',
        22244: 'TD',
        22280: 'JQ',
        22300: 'YH',
        22313: 'XW',
        22331: 'YQ',
        22343: 'YJ',
        22351: 'PH',
        22395: 'DC',
        22412: 'TD',
        22484: 'PB',
        22500: 'PB',
        22534: 'ZD',
        22549: 'DH',
        22561: 'PB',
        22612: 'TD',
        22771: 'KQ',
        22831: 'HB',
        22841: 'JG',
        22855: 'QJ',
        22865: 'XQ',
        23013: 'ML',
        23081: 'WM',
        23487: 'SX',
        23558: 'QJ',
        23561: 'YW',
        23586: 'YW',
        23614: 'YW',
        23615: 'SN',
        23631: 'PB',
        23646: 'ZS',
        23663: 'ZT',
        23673: 'YG',
        23762: 'TD',
        23769: 'ZS',
        23780: 'QJ',
        23884: 'QK',
        24055: 'XH',
        24113: 'DC',
        24162: 'ZC',
        24191: 'GA',
        24273: 'QJ',
        24324: 'NL',
        24377: 'TD',
        24378: 'QJ',
        24439: 'PF',
        24554: 'ZS',
        24683: 'TD',
        24694: 'WE',
        24733: 'LK',
        24925: 'TN',
        25094: 'ZG',
        25100: 'XQ',
        25103: 'XH',
        25153: 'PB',
        25170: 'PB',
        25179: 'KG',
        25203: 'PB',
        25240: 'ZS',
        25282: 'FB',
        25303: 'NA',
        25324: 'KG',
        25341: 'ZY',
        25373: 'WZ',
        25375: 'XJ',
        25384: 'A',
        25457: 'A',
        25528: 'SD',
        25530: 'SC',
        25552: 'TD',
        25774: 'ZC',
        25874: 'ZC',
        26044: 'YW',
        26080: 'WM',
        26292: 'PB',
        26333: 'PB',
        26355: 'ZY',
        26366: 'CZ',
        26397: 'ZC',
        26399: 'QJ',
        26415: 'ZS',
        26451: 'SB',
        26526: 'ZC',
        26552: 'JG',
        26561: 'TD',
        26588: 'JG',
        26597: 'CZ',
        26629: 'ZS',
        26638: 'YL',
        26646: 'XQ',
        26653: 'KG',
        26657: 'XJ',
        26727: 'HG',
        26894: 'ZC',
        26937: 'ZS',
        26946: 'ZC',
        26999: 'KJ',
        27099: 'KJ',
        27449: 'YQ',
        27481: 'XS',
        27542: 'ZS',
        27663: 'ZS',
        27748: 'TS',
        27784: 'SC',
        27788: 'ZD',
        27795: 'TD',
        27812: 'O',
        27850: 'PB',
        27852: 'MB',
        27895: 'SL',
        27898: 'PL',
        27973: 'QJ',
        27981: 'KH',
        27986: 'HX',
        27994: 'XJ',
        28044: 'YC',
        28065: 'WG',
        28177: 'SM',
        28267: 'QJ',
        28291: 'KH',
        28337: 'ZQ',
        28463: 'TL',
        28548: 'DC',
        28601: 'TD',
        28689: 'PB',
        28805: 'JG',
        28820: 'QG',
        28846: 'PB',
        28952: 'TD',
        28975: 'ZC',
        29100: 'A',
        29325: 'QJ',
        29575: 'SL',
        29602: 'FB',
        30010: 'TD',
        30044: 'CX',
        30058: 'PF',
        30091: 'YSP',
        30111: 'YN',
        30229: 'XJ',
        30427: 'SC',
        30465: 'SX',
        30631: 'YQ',
        30655: 'QJ',
        30684: 'QJG',
        30707: 'SD',
        30729: 'XH',
        30796: 'LG',
        30917: 'PB',
        31074: 'NM',
        31085: 'JZ',
        31109: 'SC',
        31181: 'ZC',
        31192: 'MLB',
        31293: 'JQ',
        31400: 'YX',
        31584: 'YJ',
        31896: 'ZN',
        31909: 'ZY',
        31995: 'XJ',
        32321: 'PF',
        32327: 'ZY',
        32418: 'HG',
        32420: 'XQ',
        32421: 'HG',
        32438: 'LG',
        32473: 'GJ',
        32488: 'TD',
        32521: 'QJ',
        32527: 'PB',
        32562: 'ZSQ',
        32564: 'JZ',
        32735: 'ZD',
        32793: 'PB',
        33071: 'PF',
        33098: 'XL',
        33100: 'YA',
        33152: 'PB',
        33261: 'CX',
        33324: 'BP',
        33333: 'TD',
        33406: 'YA',
        33426: 'WM',
        33432: 'PB',
        33445: 'JG',
        33486: 'ZN',
        33493: 'TS',
        33507: 'QJ',
        33540: 'QJ',
        33544: 'ZC',
        33564: 'XQ',
        33617: 'YT',
        33632: 'QJ',
        33636: 'XH',
        33637: 'YX',
        33694: 'WG',
        33705: 'PF',
        33728: 'YW',
        33882: 'SR',
        34067: 'WM',
        34074: 'YW',
        34121: 'QJ',
        34255: 'ZC',
        34259: 'XL',
        34425: 'JH',
        34430: 'XH',
        34485: 'KH',
        34503: 'YS',
        34532: 'HG',
        34552: 'XS',
        34558: 'YE',
        34593: 'ZL',
        34660: 'YQ',
        34892: 'XH',
        34928: 'SC',
        34999: 'QJ',
        35048: 'PB',
        35059: 'SC',
        35098: 'ZC',
        35203: 'TQ',
        35265: 'JX',
        35299: 'JX',
        35782: 'SZ',
        35828: 'YS',
        35830: 'E',
        35843: 'TD',
        35895: 'YG',
        35977: 'MH',
        36158: 'JG',
        36228: 'QJ',
        36426: 'XQ',
        36466: 'DC',
        36710: 'JC',
        36711: 'ZYG',
        36767: 'PB',
        36866: 'SK',
        36951: 'YW',
        37034: 'YX',
        37063: 'XH',
        37218: 'ZC',
        37325: 'ZC',
        38063: 'PB',
        38079: 'TD',
        38085: 'QY',
        38107: 'DC',
        38116: 'TD',
        38123: 'YD',
        38224: 'HG',
        38241: 'XTC',
        38271: 'ZC',
        38415: 'YE',
        38426: 'KH',
        38461: 'YD',
        38463: 'AE',
        38466: 'PB',
        38477: 'XJ',
        38518: 'YT',
        38551: 'WK',
        38585: 'ZC',
        38704: 'XS',
        38739: 'LJ',
        38761: 'GJ',
        38808: 'SQ',
        39048: 'JG',
        39049: 'XJ',
        39052: 'HG',
        39076: 'CZ',
        39271: 'XT',
        39534: 'TD',
        39552: 'TD',
        39584: 'PB',
        39647: 'SB',
        39730: 'LG',
        39748: 'TPB',
        40109: 'ZQ',
        40479: 'ND',
        40516: 'HG',
        40536: 'HG',
        40583: 'QJ',
        40765: 'YQ',
        40784: 'QJ',
        40840: 'YK',
        40863: 'QJG',
    }
    const checkCh = (ch) => {
        const uni = ch.charCodeAt(0)
        //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
        if (uni > 40869 || uni < 19968) {
            return ch
        } //dealWithOthers(ch);
        //检查是否是多音字,是按多音字处理,不是就直接在strChineseFirstPY字符串中找对应的首字母
        return oMultiDiff[uni] ? oMultiDiff[uni] : strChineseFirstPY.charAt(uni - 19968)
    }

    const mkRslt = (arr) => {
        let arrRslt = ['']
        for (let i = 0, len = arr.length; i < len; i++) {
            const str = arr[i]
            const strlen = str.length
            if (strlen == 1) {
                for (let k = 0; k < arrRslt.length; k++) {
                    arrRslt[k] += str
                }
            } else {
                const tmpArr = arrRslt.slice(0)
                arrRslt = []
                for (let k = 0; k < strlen; k++) {
                    //复制一个相同的arrRslt
                    const tmp = tmpArr.slice(0)
                    //把当前字符str[k]添加到每个元素末尾
                    for (let j = 0; j < tmp.length; j++) {
                        tmp[j] += str.charAt(k)
                    }
                    //把复制并修改后的数组连接到arrRslt上
                    arrRslt = arrRslt.concat(tmp)
                }
            }
        }
        return arrRslt
    }
    //参数,中文字符串
    //返回值:拼音首字母串数组
    var arrResult = new Array() //保存中间结果的数组
    for (var i = 0, len = str.length; i < len; i++) {
        //获得unicode码
        var ch = str.charAt(i)
        //检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
        arrResult.push(checkCh(ch))
    }
    //处理arrResult,返回所有可能的拼音首字母串数组
    return mkRslt(arrResult)
}

/**
 * @description: JS将阿拉伯数字转为中文汉字
 * @param {*} Num 阿拉伯数字
 * @returns {string} 数字对应的中文汉字
 */
export function arabiaToSimplifiedChinese(Num) {
    for (let i = Num.length - 1; i >= 0; i--) {
        Num = Num.replace(',', '') //替换Num中的“,”
        Num = Num.replace(' ', '') //替换Num中的空格
    }
    if (isNaN(Num)) {
        //验证输入的字符是否为数字
        //alert("请检查小写金额是否正确");
        return
    }
    //字符处理完毕后开始转换，采用前后两部分分别转换
    let part = String(Num).split('.')
    let newchar = ''
    //小数点前进行转化
    for (let i = part[0].length - 1; i >= 0; i--) {
        if (part[0].length > 10) {
            //alert("位数过大，无法计算");
            return ''
        } //若数量超过拾亿单位，提示
        let tmpnewchar = ''
        let perchar = part[0].charAt(i)
        switch (perchar) {
            case '0':
                tmpnewchar = '零' + tmpnewchar
                break
            case '1':
                tmpnewchar = '一' + tmpnewchar
                break
            case '2':
                tmpnewchar = '二' + tmpnewchar
                break
            case '3':
                tmpnewchar = '三' + tmpnewchar
                break
            case '4':
                tmpnewchar = '四' + tmpnewchar
                break
            case '5':
                tmpnewchar = '五' + tmpnewchar
                break
            case '6':
                tmpnewchar = '六' + tmpnewchar
                break
            case '7':
                tmpnewchar = '七' + tmpnewchar
                break
            case '8':
                tmpnewchar = '八' + tmpnewchar
                break
            case '9':
                tmpnewchar = '九' + tmpnewchar
                break
        }
        switch (part[0].length - i - 1) {
            case 0:
                tmpnewchar = tmpnewchar + ''
                break
            case 1:
                if (perchar != 0) tmpnewchar = tmpnewchar + '十'
                break
            case 2:
                if (perchar != 0) tmpnewchar = tmpnewchar + '百'
                break
            case 3:
                if (perchar != 0) tmpnewchar = tmpnewchar + '千'
                break
            case 4:
                tmpnewchar = tmpnewchar + '万'
                break
            case 5:
                if (perchar != 0) tmpnewchar = tmpnewchar + '十'
                break
            case 6:
                if (perchar != 0) tmpnewchar = tmpnewchar + '百'
                break
            case 7:
                if (perchar != 0) tmpnewchar = tmpnewchar + '千'
                break
            case 8:
                tmpnewchar = tmpnewchar + '亿'
                break
            case 9:
                tmpnewchar = tmpnewchar + '十'
                break
        }
        newchar = tmpnewchar + newchar
    }
    //替换所有无用汉字，直到没有此类无用的数字为止
    while (
        newchar.search('零零') != -1 ||
        newchar.search('零亿') != -1 ||
        newchar.search('亿万') != -1 ||
        newchar.search('零万') != -1
    ) {
        newchar = newchar.replace('零亿', '亿')
        newchar = newchar.replace('亿万', '亿')
        newchar = newchar.replace('零万', '万')
        newchar = newchar.replace('零零', '零')
    }
    //替换以“一十”开头的，为“十”
    if (newchar.indexOf('一十') == 0) {
        newchar = newchar.substr(1)
    }
    //替换以“零”结尾的，为“”
    if (newchar.lastIndexOf('零') == newchar.length - 1) {
        newchar = newchar.substr(0, newchar.length - 1)
    }
    return newchar
}

/**
 * @description: 获取文件mime类型
 * @param {*} type 文件类型，可以是扩展名、文件名、文件路径，例如 'folder/file.js'
 * @returns {string} 文件mime类型
 */
export function getMimeType(type) {
    return mime.lookup(type) ? mime.lookup(type) : type
}

/**
 * 数组元素交换位置
 * @param {array} arr 数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */

export function swapArray(arr, index1, index2) {
    arr[index1] = arr.splice(index2, 1, arr[index1])[0]
    return arr
}

/**
 * 数组中查找当前元素的上一个元素
 * @param {array} arr 数组
 * @param {object} item 当前元素
 * @param {boolean} isPrev true 返回上一个元素，false 返回下一个元素
 * @param {string} field 比较属性名
 */

export function findSibling(arr = [], item = {}, isPrev, field = 'id') {
    if (!item) return
    const currentIdx = arr.findIndex((val) => val[field] === item[field])
    const newIdx = isPrev ? currentIdx - 1 : currentIdx + 1
    return arr[newIdx]
}
